export * from "/__w/wiggot-web/wiggot-web/packages/web-components/constants/gender.ts"